import { MenuNode } from "../reordering";

export const sample: MenuNode[] = [
  // ── Level 1: B1 - Gramar Bank ─────────────────────────────────────────────
  {
    archiveId: 1,
    parentId: null,
    nodeType: "hospital",
    name: "B1 - Gramar Bank",
    staffId: "",
    label: "Chief Executive Officer",
    phone: "+1-555-8000",
    email: "admin@metrogeneral.org",
    type: "",
    yearsExperience: null,
    isPage: false,
    patientCapacity: 750,
    certifications: [],
    hireDate: new Date(1987, 4, 8),
    isSelected: false,
    icon: "directions",
  },

  // ── Level 2: Catégories ────────────────────────────────────────
  {
    archiveId: 2,
    parentId: 1,
    nodeType: "division",
    name: "1A - Present simple and continuous, action and non-action verbs",
    staffId: "",
    label: "Division Chief, Surgery",
    phone: "+1-555-8010",
    email: "surgery@metrogeneral.org",
    type: "",
    yearsExperience: 28,
    isPage: false,
    patientCapacity: 180,
    certifications: ["ABS Board Certified"],
    hireDate: new Date(1998, 7, 15),
    isSelected: false,
    icon: "connector",
  },
  {
    archiveId: 3,
    parentId: 1,
    nodeType: "division",
    name: "1B - Future forms: present continuous, be going to, will/won't",
    staffId: "",
    label: "Division Chief, Internal Medicine",
    phone: "+1-555-8020",
    email: "internal.medicine@metrogeneral.org",
    type: "",
    yearsExperience: 25,
    isPage: false,
    patientCapacity: 210,
    certifications: ["ABIM Board Certified"],
    hireDate: new Date(2001, 10, 22),
    isSelected: false,
    icon: "connector",
  },
  {
    archiveId: 4,
    parentId: 3,
    nodeType: "division",
    name: "Present continuous",
    staffId: "",
    label: "Division Chief, Emergency Medicine",
    phone: "+1-555-8040",
    email: "emergency@metrogeneral.org",
    type: "",
    yearsExperience: 20,
    isPage: false,
    patientCapacity: 100,
    certifications: ["ABEM Board Certified"],
    hireDate: new Date(2006, 4, 9),
    isSelected: false,
    icon: "arrow-right",
  },
  {
    archiveId: 5,
    parentId: 3,
    nodeType: "division",
    name: "Be going to",
    staffId: "",
    label: "Division Chief, Emergency Medicine",
    phone: "+1-555-8040",
    email: "emergency@metrogeneral.org",
    type: "",
    yearsExperience: 20,
    isPage: false,
    patientCapacity: 100,
    certifications: ["ABEM Board Certified"],
    hireDate: new Date(2006, 4, 9),
    isSelected: false,
    icon: "arrow-right",
  },
  {
    archiveId: 6,
    parentId: 3,
    nodeType: "division",
    name: "Will/won't",
    staffId: "",
    label: "Division Chief, Emergency Medicine",
    phone: "+1-555-8040",
    email: "emergency@metrogeneral.org",
    type: "",
    yearsExperience: 20,
    isPage: false,
    patientCapacity: 100,
    certifications: ["ABEM Board Certified"],
    hireDate: new Date(2006, 4, 9),
    isSelected: false,
    icon: "arrow-right",
  },
  {
    archiveId: 7,
    parentId: 1,
    nodeType: "division",
    name: "5A - Past tenses: simple, continuous, perfect",
    staffId: "",
    label: "Division Chief, Pediatrics",
    phone: "+1-555-8030",
    email: "pediatrics@metrogeneral.org",
    type: "",
    yearsExperience: 22,
    isPage: false,
    patientCapacity: 130,
    certifications: ["ABP Board Certified"],
    hireDate: new Date(2004, 1, 2),
    isSelected: false,
    icon: "connector",
  },
  {
    archiveId: 8,
    parentId: 7,
    nodeType: "division",
    name: "Past simple",
    staffId: "",
    label: "Division Chief, Emergency Medicine",
    phone: "+1-555-8040",
    email: "emergency@metrogeneral.org",
    type: "",
    yearsExperience: 20,
    isPage: false,
    patientCapacity: 100,
    certifications: ["ABEM Board Certified"],
    hireDate: new Date(2006, 4, 9),
    isSelected: false,
    icon: "arrow-right",
  },
  {
    archiveId: 9,
    parentId: 7,
    nodeType: "division",
    name: "Past continuous",
    staffId: "",
    label: "Division Chief, Emergency Medicine",
    phone: "+1-555-8040",
    email: "emergency@metrogeneral.org",
    type: "",
    yearsExperience: 20,
    isPage: false,
    patientCapacity: 100,
    certifications: ["ABEM Board Certified"],
    hireDate: new Date(2006, 4, 9),
    isSelected: false,
    icon: "arrow-right",
  },
  {
    archiveId: 10,
    parentId: 7,
    nodeType: "division",
    name: "Past perfect",
    staffId: "",
    label: "Division Chief, Emergency Medicine",
    phone: "+1-555-8040",
    email: "emergency@metrogeneral.org",
    type: "",
    yearsExperience: 20,
    isPage: false,
    patientCapacity: 100,
    certifications: ["ABEM Board Certified"],
    hireDate: new Date(2006, 4, 9),
    isSelected: false,
    icon: "arrow-right",
  },
  {
    archiveId: 11,
    parentId: 1,
    nodeType: "division",
    name: "6A - Passive (all tenses)",
    staffId: "",
    label: "Division Chief, Pediatrics",
    phone: "+1-555-8030",
    email: "pediatrics@metrogeneral.org",
    type: "",
    yearsExperience: 22,
    isPage: false,
    patientCapacity: 130,
    certifications: ["ABP Board Certified"],
    hireDate: new Date(2004, 1, 2),
    isSelected: false,
    icon: "connector",
  },
  {
    archiveId: 12,
    parentId: 1,
    nodeType: "division",
    name: "7A - First conditional and future time clauses + when, until, etc…",
    staffId: "",
    label: "Division Chief, Pediatrics",
    phone: "+1-555-8030",
    email: "pediatrics@metrogeneral.org",
    type: "",
    yearsExperience: 22,
    isPage: false,
    patientCapacity: 130,
    certifications: ["ABP Board Certified"],
    hireDate: new Date(2004, 1, 2),
    isSelected: false,
    icon: "connector",
  },
  {
    archiveId: 13,
    parentId: 1,
    nodeType: "division",
    name: "7B - Second conditional, choosing between conditions",
    staffId: "",
    label: "Division Chief, Pediatrics",
    phone: "+1-555-8030",
    email: "pediatrics@metrogeneral.org",
    type: "",
    yearsExperience: 22,
    isPage: false,
    patientCapacity: 130,
    certifications: ["ABP Board Certified"],
    hireDate: new Date(2004, 1, 2),
    isSelected: false,
    icon: "connector",
  },
  // ── Level 3: ─────────────────────────────────────────────
  {
    archiveId: 100,
    parentId: 2,
    nodeType: "unit",
    name: "Le present continuous",
    staffId: "",
    label: "Unit Supervisor",
    phone: "+1-555-8011",
    email: "cv.surgery@metrogeneral.org",
    type: "Texte",
    bloc: `<h2>Le present continuous</h2>
<p>On utilise le present continuous pour décrire quelque chose qui est <span style="background-color: rgb(255, 255, 0);">entrain de se passer</span>.</p>
<p>On utilise l'auxiliaire <i>to be</i> à la bonne personne suivit d'un verbe en <i>-ing</i>.</p>`,
    yearsExperience: 20,
    isPage: false,
    patientCapacity: 60,
    certifications: ["ABS Cardiac Surgery"],
    hireDate: new Date(2006, 10, 23),
    isSelected: false,
    isEdit: false,
    icon: "star",
    lastEdit: new Date(2026, 1, 1),
  },
  {
    archiveId: 101,
    parentId: 2,
    nodeType: "unit",
    name: "Le present simple vs continuous",
    staffId: "",
    label: "Unit Supervisor",
    phone: "+1-555-8013",
    email: "neuro.surgery@metrogeneral.org",
    type: "Texte",
    bloc: `<h2>Le present simple vs continuous</h2>
<p>Present simple : <b>exprime une idée en général</b></p>
<p>On utilise souvent le present simple pour parler de la routine et des habitudes récurantes:</p>
<p style="margin-inline-start: 30px;"><i>I study every Saturday.<br>I never study on Monday</i></p>
<p>Tout comme en français avec le présent on peut utiliser le present continuous pour parler de projets futurs :</p>
<p style="margin-inline-start: 30px;"><i>This weekend I'm playing soccer with Sahra</i><br><i>Ce weekend je joue avec Sarah</i></p>`,
    yearsExperience: 22,
    isPage: false,
    patientCapacity: 50,
    certifications: ["ABNS Board Certified"],
    hireDate: new Date(2004, 4, 10),
    isSelected: false,
    isEdit: false,
    icon: "inbox",
    lastEdit: new Date(2026, 1, 1),
  },
  // Under 1B
  {
    archiveId: 102,
    parentId: 4,
    nodeType: "unit",
    name: "Present continuous vs futur forms",
    staffId: "",
    label: "Ward Supervisor",
    phone: "+1-555-8021",
    email: "cardiology@metrogeneral.org",
    type: "Texte",
    bloc: `<h2>Present continuous vs futur forms</h2>
<p>On utilise souvent le present continuous pour des arrangement futur.</p>
<p>Il y a une petite différance :</p>
<p style="margin-inline-start: 30px;">
  <i>be going to</i> : montre que la décision est prise<br>
  <span style="background-color: rgb(255, 255, 0);">present continuous</span>: met en valeur que tu as fait un arrangement
</p>
<p>Example:</p>
<p style="margin-inline-start: 30px;">
  <i>We're going to get married next year.<br>
  We're getting married on October 12th (= <span style="background-color: rgb(255, 255, 0);"> l'église est réservé</span>)</i>
</p>
<p>A propos du present continuous:</p>
<p style="margin-inline-start: 30px;">
On utilise souvent cette forme avec des verbes relatif aux <span style="background-color: rgb(255, 255, 0);">voyages</span><br>
<br>
<i>go<br>come<br>arrive<br>leave<br>etc...</i><br>
<br>
<i>(He's arriving tomorrow and leaving on Thursday)</i></p>`,
    yearsExperience: 16,
    isPage: false,
    patientCapacity: 80,
    certifications: ["ABIM Cardiology"],
    hireDate: new Date(2010, 7, 17),
    isSelected: false,
    isEdit: false,
    icon: "star",
    lastEdit: new Date(2026, 1, 1),
  },
  {
    archiveId: 103,
    parentId: 5,
    nodeType: "unit",
    name: "going to",
    staffId: "",
    label: "Ward Supervisor",
    phone: "+1-555-8023",
    email: "gastro@metrogeneral.org",
    type: "Texte",
    bloc: `<h2>going to</h2>
<p>On utilise going to quand on a déjà décidé de faire quelque chose.</p>
<p>On peut aussi l'utiliser pour les prédictions, spécialement quand il y a evidence</p>`,
    yearsExperience: 17,
    isPage: false,
    patientCapacity: 60,
    certifications: ["ABIM Gastroenterology"],
    hireDate: new Date(2009, 1, 4),
    isSelected: false,
    isEdit: false,
    icon: "star",
    lastEdit: new Date(2026, 1, 1),
  },
  {
    archiveId: 104,
    parentId: 6,
    nodeType: "unit",
    name: "will / shall + inf",
    staffId: "",
    label: "Ward Supervisor",
    phone: "+1-555-8022",
    email: "pulmonology@metrogeneral.org",
    type: "Texte",
    bloc: `<h2>will / shall + inf</h2>
<p><h3>will / won't:</h3>Pour des decisions, promesse, offre<br>On peut utiliser pour des predictions</p>
<p style="margin-inline-start: 30px;"><i>I think Barcelona will win</i><br>
<i>The election will be on 1st March</i></p>
<p><h3>shall:</h3> <span style="background-color: rgb(255, 255, 0);">We + I</span></p>`,
    yearsExperience: 14,
    isPage: false,
    patientCapacity: 70,
    certifications: ["ABIM Pulmonary Disease"],
    hireDate: new Date(2012, 10, 24),
    isSelected: false,
    isEdit: false,
    icon: "star",
    lastEdit: new Date(2026, 1, 1),
  },
  // Under Past simple
  {
    archiveId: 105,
    parentId: 8,
    nodeType: "unit",
    name: "Past simple",
    staffId: "",
    label: "Ward Supervisor",
    phone: "+1-555-8032",
    email: "peds.ward@metrogeneral.org",
    type: "Texte",
    bloc: `<h2>Past simple</h2>
<p>Le past simple est utilisé pour parler d'événements ou d'actions qui ont lieu à un moment défini dans le passé et qui sont <span style="color: rgb(255, 0, 0);">terminés</span>.</p>
<p>Les actions dont il est question peuvent <span style="color: rgb(255, 0, 0);">être ponctuel ou se répéter</span>. Elles peuvent <span style="color: rgb(255, 0, 0);">aussi se succéder</span>.</p>
<p style="margin-inline-start: 30px;"><span style="font-family: &quot;Courier New&quot;, Courier, &quot;Lucida Sans Typewriter&quot;, &quot;Lucida Typewriter&quot;, monospace;">---------&gt; x&nbsp;&nbsp; |<br>Past &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; | Now</span></p>
<p>Exemple <span style="background-color: rgb(255, 255, 0);">terminé</span>:</p>
<p style="margin-inline-start: 30px;"><i>I <span style="color: rgb(255, 0, 0);"><u>played</u></span> football <u>yesterday</u></i></p>
<p>Exemple <span style="background-color: rgb(255, 255, 0);">ponctuelles ou se répéter</span>:</p>
<p style="margin-inline-start: 30px;"><i>She <span style="color: rgb(255, 0, 0);"><u>visited</u></span> her grandmother <u>every weekend</u></i></p>
<p>Exemple <span style="background-color: rgb(255, 255, 0);">succéder</span>:</p>
<p style="margin-inline-start: 30px;"><i>He <span style="color: rgb(255, 0, 0);"><u>arrived</u></span> home and <span style="color: rgb(255, 0, 0);"><u>enjoyed</u></span> a cup of coffee</i></p>
<h3>Exemple normal/négatif/question:</h3>
<p>Exemple normal:</p>
<p style="margin-inline-start: 30px;"><i>She cooked her breakfast in the morning.</i></p>
<p>Exemple négatif:</p>
<p style="margin-inline-start: 30px;"><i>She didn't cook her breakfast in the morning.</i></p>
<p>Exemple question:</p>
<p style="margin-inline-start: 30px;"><i>Did she cook her breakfast in the morning?<br>Yes, she did;<br>No, she didnt.</i></p>`,
    yearsExperience: 14,
    isPage: false,
    patientCapacity: 98,
    certifications: ["ABP Board Certified"],
    hireDate: new Date(2012, 7, 18),
    isSelected: false,
    isEdit: false,
    icon: "arrow-right",
    lastEdit: new Date(2026, 1, 1),
  },
  // Under Past continuous
  {
    archiveId: 106,
    parentId: 9,
    nodeType: "unit",
    name: "Past continuous",
    staffId: "",
    label: "Ward Supervisor",
    phone: "+1-555-8032",
    email: "peds.ward@metrogeneral.org",
    type: "Texte",
    bloc: `<h2>Past continuous</h2>
<p>Le passé continuous est utilisé quand quelque chose était en cours et quelque chose arrive.</p>
<p>Il y a une notion: <span style="background-color: rgb(255, 255, 0);">Movie theater inside</span></p>
<p style="margin-inline-start: 30px;"><span style="font-family: &quot;Courier New&quot;, Courier, &quot;Lucida Sans Typewriter&quot;, &quot;Lucida Typewriter&quot;, monospace;">---------++&gt; x&nbsp;&nbsp;      |<br>Past &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; | Now</span></p>
<h3>Explication OXFORD</h3>
<p>1) <i>What <span style="color: rgb(255, 0, 0);">were</span> you <span style="color: rgb(255, 0, 0);">doing</span> at six o'clock last night?</i>&nbsp;<span style="background-color: rgb(255, 255, 0);">*</span></p>
<p style="margin-inline-start: 30px;">On utilise le past continuous pour parler de quelque chose en progression à un moment spécifique dans le passé.<br>
<span style="background-color: rgb(255, 255, 0);">* Ne pas utilise passé continuous avec non-action verb</span></p>
<p>2) <i>I <span style="color: rgb(255, 0, 0);">was driving</span> along the motorway when it started snowing.</i></p>
<p style="margin-inline-start: 30px;">On utilise souvent le pas continuous pour décrire une action passé en progression qui a été interrompue par une autre action <b>(past simple)</b>. Les deux actions sont en général lié par <b>when</b> ou <b>as</b>.</p>
<p>3) <i>While I <span style="color: rgb(255, 0, 0);">was doing</span> the housework, the children <span style="color: rgb(255, 0, 0);">were playing</span> in the garden</i>.</p>
<p style="margin-inline-start: 30px;">On utilise souvent le past continuous avec <b>while</b>, quand deux actions arrive en même temps.</p>
<p>4) <i>It was a cold night and it <span style="color: rgb(255, 0, 0);">was raining</span>. I <span style="color: rgb(255, 0, 0);">was watching</span> TV in the living room</i>.</p>
<p style="margin-inline-start: 30px;">On utilise souvent le past continuous pour décrire ce qui se passait au début d'une histoire ou d'une anecdote.</p>`,
    yearsExperience: 14,
    isPage: false,
    patientCapacity: 98,
    certifications: ["ABP Board Certified"],
    hireDate: new Date(2012, 7, 18),
    isSelected: false,
    isEdit: false,
    icon: "arrow-right",
    lastEdit: new Date(2026, 1, 1),
  },
  // Under Past perfect
  {
    archiveId: 107,
    parentId: 10,
    nodeType: "unit",
    name: "Past perfect",
    staffId: "",
    label: "Ward Supervisor",
    phone: "+1-555-8032",
    email: "peds.ward@metrogeneral.org",
    type: "Texte",
    bloc: `<h2>Past perfect</h2>
<p>Le past perfect sert à parler d'événement ou d'action qui ont eu lieu <span style="background-color: rgb(255, 255, 0);">avant un autre événement du passé</mark>.</p>
<p style="margin-inline-start: 30px;"><i>He was late for dinner, we <span style="color: rgb(255, 0, 0);">had</span> already <span style="color: rgb(255, 0, 0);">eaten</span> when he arrived.</i><br><span style="background-color: rgb(255, 255, 0);"><b>L'action de manger a précédé celle d'arriver</b></p>
<p>Former le past perfect:</p>
<p style="margin-inline-start: 30px;">Le past perfect est très simple à former: <b>on utilise</b></p>
<p style="margin-inline-start: 60px;"><i><span style="color: rgb(255, 0, 0);">had</span> + <span style="color: rgb(255, 0, 0);">p.p</span> du verbe principal</p>
<p style="margin-inline-start: 30px;"><i>He <span style="color: rgb(255, 0, 0);">had</span> already <span style="color: rgb(255, 0, 0);">picked</span> up the tickets for the concert.</i></p>
<p style="margin-inline-start: 30px;"><i>She lent him the film that she <span style="color: rgb(255, 0, 0);">had</span> already <span style="color: rgb(255, 0, 0);">watched</span>.</i></p>
<p style="margin-inline-start: 30px;"><i>We <span style="color: rgb(255, 0, 0);">had</span> just <span style="color: rgb(255, 0, 0);">finished</span> dinner when they <span style="color: rgb(255, 0, 0);">arrived</span>.</i></p>
<p>Le simple past est utilisé quand on parle d'une action achevée ou passé.</p>
<p style="margin-inline-start: 30px;"><i>I <span style="color: rgb(255, 0, 0);">ventured</span> onto the black slopes while skiing</i><br>Je me suis aventuré sur les pistes noires en skiant.</p>
<p>Le past perfect quand on parle d'une action au passé qui a lieu <span style="background-color: rgb(255, 255, 0);">avant</span> une autre action. <span style="background-color: rgb(255, 255, 0);">C'est-à-dire un plus-que-parfait.</span></p>
<p style="margin-inline-start: 30px;">I <span style="color: rgb(255, 0, 0);">had</span> never <span style="color: rgb(255, 0, 0);">ventured</span> onto the black slopes <span style="color: rgb(255, 0, 0);">before</span> I went to Aspen.<br>Je m'étais jamais aventuré sur les pistes noires avant d'aller à Aspen.</p>
<h3>Exemple OXFORD</h3>
<p style="margin-inline-start: 30px;"><i>When they turned on the TV, the match <span style="color: rgb(255, 0, 0);">had</span> already <span style="color: rgb(255, 0, 0);">finished</span></p>
<p style="margin-inline-start: 30px;"><i>As soon as I shut the door, I realized that I'<span style="color: rgb(255, 0, 0);">d left</span> my keys on the table.</p>
<p style="margin-inline-start: 30px;"><i>We couldn't get a table in the restaurant because we <span style="color: rgb(255, 0, 0);">hadn't booked</span>.</p>
<p style="margin-inline-start: 30px;">On utilise le <span style="background-color: rgb(255, 255, 0);">past perfect</span> quand on est entrain de parler à propos du <b>passé</b> et quand on veut parler à propos d'une <b>action antérieur</b>.</p>
<p style="margin-inline-start: 30px;"><i>When John arrived, they <span style="color: rgb(255, 0, 0);">went out</span>.</p>
<p style="margin-inline-start: 60px;">1) John est arrivé</p>
<p style="margin-inline-start: 60px;">2) <b>après,</b> ils sont sortis</p>
<p style="margin-inline-start: 30px;"><i>When John arrived, they <span style="color: rgb(255, 0, 0);">had gone out</span>.</p>
<p style="margin-inline-start: 60px;">1) Ils sont sortis <b>avant</b> que John est arrivé</p>
<p style="margin-inline-start: 30px;">Il y a cette notion de <span style="background-color: rgb(255, 255, 0);">flashback</span></p>`,
    yearsExperience: 14,
    isPage: false,
    patientCapacity: 98,
    certifications: ["ABP Board Certified"],
    hireDate: new Date(2012, 7, 18),
    isSelected: false,
    isEdit: false,
    icon: "arrow-right",
    lastEdit: new Date(2026, 1, 1),
  },
  // 6A
  {
    archiveId: 108,
    parentId: 11,
    nodeType: "unit",
    name: "Passive (all tenses)",
    staffId: "",
    label: "Ward Supervisor",
    phone: "+1-555-8032",
    email: "peds.ward@metrogeneral.org",
    type: "Texte",
    bloc: `<h2>L'emploi de la voix passive</h2>
<p>Tout comme en français, on utilise la voix passive lorsque l'on met l'accent sur <span style="background-color: rgb(255, 255, 0);">l'action</span> de la phrase.</p>
<p>La personne qui accomplit l'action est introduit par <span style="color: rgb(255, 0, 0);">by</span>.</p>
<p>Exemple:</p>
<p style="margin-inline-start: 30px;"><i>The emergency room <span style="color: rgb(255, 0, 0);">is cleaned</span> every day by me.</i></p>
<p style="margin-inline-start: 60px;">Ici, l'accent est mis sur l'action <span style="color: rgb(255, 0, 0);">is cleaned</span>.</p>
<p>On emploie également la voix passive lorsqu'on ne sait pas par qui <u>sans importance</u>.</p>
<p>Exemple:</p>
<p style="margin-inline-start: 30px;"><i>The book <span style="color: rgb(255, 0, 0);">is written</span> in English.</i></p>
<h2>Former la voix passive</h2>
<p>On forme la voix passive avec le verbe <span style="color: rgb(255, 0, 0);">to be</span> + <span style="color: rgb(255, 0, 0);">p.p.</span></p>
<p>Exemple:</p>
<p style="margin-inline-start: 30px;"><i>The book <span style="color: rgb(255, 0, 0);">is written</span> in English.</i><br>Si l'intention est d'accentuer sur la durée d'un processus on utilise <span style="background-color: rgb(255, 255, 0);">le present progressive</span>.</p>
<p>Exemple:</p>
<p style="margin-inline-start: 30px;"><i>The book <span style="color: rgb(255, 0, 0);">is being written</span> as we speak.</i><br>Puisque le livre est écrit exactement à ce moment-là (à l'heure où nous parlons), on utilise <span style="background-color: rgb(255, 255, 0);">le present progressive</span></p>`,
    yearsExperience: 14,
    isPage: false,
    patientCapacity: 98,
    certifications: ["ABP Board Certified"],
    hireDate: new Date(2012, 7, 18),
    isSelected: false,
    isEdit: false,
    icon: "arrow-right",
    lastEdit: new Date(2026, 1, 1),
  },
  // 7A
  {
    archiveId: 109,
    parentId: 12,
    nodeType: "unit",
    name: "First conditional",
    staffId: "",
    label: "Ward Supervisor",
    phone: "+1-555-8032",
    email: "peds.ward@metrogeneral.org",
    type: "Texte",
    bloc: `<h2>First conditional</h2>
<p>On utilise le first conditional pour parler de situation <span style="background-color: rgb(255, 255, 0);">possible</span>/<span style="background-color: rgb(255, 255, 0);">probable</span> et ses conséquences.</p>
<p>Exemple 1:</p>
<p style="margin-inline-start: 30px;"><i>If you <span style="color: rgb(255, 0, 0);">work</span> hard, you'<span style="color: rgb(255, 0, 0);">'ll pass</span> your exams.</i><br><span style="background-color: rgb(255, 255, 0);">On utilise le <b>présent</b> après if !</span></p>
<p>Exemple 2:</p>
<p style="margin-inline-start: 30px;"><i><span style="color: rgb(255, 0, 0);">Come</span> and see us next week if you <span style="color: rgb(255, 0, 0);">have</span> time.</i><br><span style="background-color: rgb(255, 255, 0);">On utilise <b>l'impératif</b> à la place de <span style="color: rgb(255, 0, 0);">will</span>.</span></p>
<p>Exemple 3:</p>
<p style="margin-inline-start: 30px;"><i>Alison <span style="color: rgb(255, 0, 0);">won't get</span> into university unless she <span style="color: rgb(255, 0, 0);">gets</span> good grades.<br>I <span style="color: rgb(255, 0, 0);">won't go</span> unless you <span style="color: rgb(255, 0, 0);">go</span> too.</i><br><span style="background-color: rgb(255, 255, 0);">On peut utiliser <span style="color: rgb(255, 0, 0);">unless</span> <b>+ past simple</b> à la place de <span style="color: rgb(255, 0, 0);">if…not</span>.</span></p>
<p>Comparaison:</p>
<p style="margin-inline-start: 30px;"><i>Alison <span style="color: rgb(255, 0, 0);">won't get</span> into university <span style="color: rgb(255, 0, 0);">if</span> she <span style="color: rgb(255, 0, 0);">doesnt' get</span> good grades.</p>
`,
    yearsExperience: 14,
    isPage: false,
    patientCapacity: 98,
    certifications: ["ABP Board Certified"],
    hireDate: new Date(2012, 7, 18),
    isSelected: false,
    isEdit: false,
    icon: "arrow-right",
    lastEdit: new Date(2026, 1, 1),
  },
  // 7B
  {
    archiveId: 110,
    parentId: 13,
    nodeType: "unit",
    name: "Second conditional",
    staffId: "",
    label: "Ward Supervisor",
    phone: "+1-555-8032",
    email: "peds.ward@metrogeneral.org",
    type: "Texte",
    bloc: `<h2>Second conditional</h2>
<p>On utilise le second conditional pour parler de situation: <span style="background-color: rgb(255, 255, 0);">hypothetical</span>/<span style="background-color: rgb(255, 255, 0);">imagined</span>/<span style="background-color: rgb(255, 255, 0);">improbable</span>/<span style="background-color: rgb(255, 255, 0);">almost impossible</span></p>
<p>Exemple:</p>
<p style="margin-inline-start: 30px;"><i>If I <span style="color: rgb(255, 0, 0);">had</span> the money, I<span style="color: rgb(255, 0, 0);">'d</span> move out.</i><br>
<br>
À propos de la phrase: <i>If I had the money</i>:<br><span style="background-color: rgb(255, 255, 0);">But I don't</span><br>
<br>
À propos de la phrase: <i>I'd move out</i>:<br><span style="background-color: rgb(255, 255, 0);">But I can't</span></p>
<h3>Exemple OXFORD</h3>
<p>Exemple A)</p>
<p style="margin-inline-start: 30px;"><i>If I <span style="color: rgb(255, 0, 0);">had</span> a job, I<span style="color: rgb(255, 0, 0);">'d get</span> my own flat.</p>
<p style="margin-inline-start: 60px;">On utilise le second conditional pour parler à propos d'un <span style="background-color: rgb(255, 255, 0);">hypothétique</span> ou <span style="background-color: rgb(255, 255, 0);">imaginaire</span> <b>present</b> ou <b>futur</b> situation et ses conséquences<br>
<br><u>if + past simple</u><br>
<u>I would/wouldn't + infinitif</u><br><br>
On utilise le <b>past simple</b> après <span style="background-color: rgb(255, 255, 0);">if</span> et <span style="background-color: rgb(255, 255, 0);">would/wouldn't + infinitif</span></p>
<p>Exemple 1)</p>
<p style="margin-inline-start: 30px;">I <span style="color: rgb(255, 0, 0);">would get on</span> better with my parent if I <span style="color: rgb(255, 0, 0);">didn't live</span> with them.<br>
I <span style="color: rgb(255, 0, 0);">wouldn't do</span> that job <span style="color: rgb(255, 0, 0);">unless</span> they <span style="color: rgb(255, 0, 0);">paid me</span> a really good salary.</p>
<p>Exemple 2)</p>
<p style="margin-inline-start: 30px;">If your sister <span style="color: rgb(255, 0, 0);">were</span> here, she <span style="color: rgb(255, 0, 0);">'d know</span> what to do.<br>
If it <span style="color: rgb(255, 0, 0);">was</span> warmer, we <span style="color: rgb(255, 0, 0);">could have</span> a swim.</p>
<p style="margin-inline-start: 60px;">On peut utiliser <b>could</b> à la place de <b>would</b>.</p>
<p>Exemple 3)</p>
<p style="margin-inline-start: 30px;">If I <span style="color: rgb(255, 0, 0);">were</span> you, <span style="color: rgb(255, 0, 0);">I'd buy</span> a new computer.</p>
<p style="margin-inline-start: 60px;">On utilise toujours le 2<sup>ème</sup> conditional commençant par : <span style="background-color: rgb(255, 255, 0);">If I were you, I'd</span> pour donner un conseil.</p>`,
    yearsExperience: 14,
    isPage: false,
    patientCapacity: 98,
    certifications: ["ABP Board Certified"],
    hireDate: new Date(2012, 7, 18),
    isSelected: false,
    isEdit: false,
    icon: "arrow-right",
    lastEdit: new Date(2026, 1, 1),
  },
];
